import { render, staticRenderFns } from "./materialImgForm.vue?vue&type=template&id=1113a39d&scoped=true"
import script from "./materialImgForm.vue?vue&type=script&lang=js"
export * from "./materialImgForm.vue?vue&type=script&lang=js"
import style0 from "./materialImgForm.vue?vue&type=style&index=0&id=1113a39d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1113a39d",
  null
  
)

export default component.exports